"use strict";

var _regeneratorRuntime = require("/Users/ryanmulligan/Developer/gatsby/dotcom/node_modules/@babel/runtime/regenerator/index.js");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var launchdarkly_js_client_sdk_1 = require("launchdarkly-js-client-sdk");

var utils_1 = require("./utils");

var packageInfo = __importStar(require("../package.json"));

var wrapperOptions = {
  wrapperName: 'react-client-sdk',
  wrapperVersion: packageInfo.version,
  sendEventsOnlyForVariation: true
};
/**
 * Internal function to initialize the `LDClient`.
 *
 * @param clientSideID Your project and environment specific client side ID
 * @param user A LaunchDarkly user object
 * @param options LaunchDarkly initialization options
 * @param targetFlags If specified, `launchdarkly-react-client-sdk` will only request and listen to these flags.
 * Flag keys must be in their original form as known to LaunchDarkly rather than in their camel-cased form.
 *
 * @see `ProviderConfig` for more details about the parameters
 * @return An initialized client and flags
 */

var initLDClient = function initLDClient(clientSideID) {
  var user = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    anonymous: true
  };
  var options = arguments.length > 2 ? arguments[2] : undefined;
  var targetFlags = arguments.length > 3 ? arguments[3] : undefined;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var ldClient;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            ldClient = (0, launchdarkly_js_client_sdk_1.initialize)(clientSideID, user, Object.assign(Object.assign({}, wrapperOptions), options));
            return _context.abrupt("return", new Promise(function (resolve) {
              function cleanup() {
                ldClient.off('ready', handleReady);
                ldClient.off('failed', handleFailure);
              }

              function handleFailure(error) {
                cleanup();
                resolve({
                  flags: {},
                  ldClient: ldClient,
                  error: error
                });
              }

              function handleReady() {
                cleanup();
                var flags = (0, utils_1.fetchFlags)(ldClient, targetFlags);
                resolve({
                  flags: flags,
                  ldClient: ldClient
                });
              }

              ldClient.on('failed', handleFailure);
              ldClient.on('ready', handleReady);
            }));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};

exports.default = initLDClient;